import { DropDownItem } from '../../../fields/dropdown-item.model';
import { Range } from '../../entities/range.model';
import { Table } from '../../entities/table.model';


export class DropDownItemsTable extends Table<{ [fieldId: number]: { range: Range, items: DropDownItem[]; }; }> {
    constructor(
        range: Range) {
        super(range, false, {});
    }

    add(fieldId: number, items: DropDownItem[]): boolean {
        if (!this.exists(fieldId)) {
            const rowCount = items.length * 3 /* ids + codes + values */ + 1; /* items count */
            const rowDiff = rowCount - (this.range.rowCount - 1 /* header */);

            if (rowDiff > 0) {
                this.range.rowCount += rowDiff;
            }

            if (this.containsData) {
                this.range.columnCount++;
            } else {
                this.containsData = true;
            }

            const range = new Range(
                items.length * 2 /* ids + codes */ + 2 /* header + items count */,
                this.range.lastColumnIndex,
                items.length,
                1,
                this.range.sheetName);

            this.cache[fieldId] = { range: range, items: items };
            return true;
        }

        return false;
    }

    remove(fieldId: number): boolean {
        if (this.exists(fieldId)) {
            delete this.cache[fieldId];

            if (this.range.columnCount == 1) {
                this.containsData = false;
            } else {
                this.range.columnCount--;
            }

            return true;
        }

        return false;
    }

    getItems(fieldId: number): DropDownItem[] {
        const items = this.cache[fieldId]?.items;
        return items ? [...items] : undefined;
    }

    getRange(fieldId: number): Range {
        return this.cache[fieldId]?.range;
    }

    exists(fieldId: number): boolean {
        return this.cache.hasOwnProperty(fieldId);
    }
}